<div class="card p-5">
  <!-- Card Header -->
  <div class="text-lg font-semibold  pb-2 mb-4">
    Create a Deleted Blotter Record Report
  </div>

  <!-- Card Body -->
  <div class="space-y-4">
    <!-- Date fields and export button -->
    <div class="flex flex-wrap items-end gap-4">
      <!-- Start Date -->
      <div class="flex flex-col">
        <label class="mb-1 text-sm font-medium">Start Date</label>
        <kendo-datepicker
          placeholder="Start Date"
          [(ngModel)]="ngModelDate"
          style="width: 200px;"
        ></kendo-datepicker>
      </div>

      <!-- End Date -->
      <div class="flex flex-col">
        <label class="mb-1 text-sm font-medium">End Date</label>
        <kendo-datepicker
          placeholder="End Date"
          [(ngModel)]="ngModelendDate"
          style="width: 200px;"
        ></kendo-datepicker>
      </div>

      <!-- Export Button -->
      <button
        type="button"
        kendoButton
        class="w-52 bg-blue-600 text-white hover:bg-blue-700 transition rounded-md"
        (click)="ExportToExcel(excelexportDeleted)"
      >
        Export To Excel
      </button>
    </div>

    <!-- Report Type Dropdown -->
<!--     <kendo-dropdownlist
      class="w-64"
      [data]="[
        { text: 'All Transactions', value: 1 },
        { text: 'Non-Rep Entered Transactions', value: 2 },
        { text: 'Summary of Non-Rep Entered Transactions', value: 3 },
        { text: 'ALL Transactions Short', value: 4 }
      ]"
      textField="text"
      valueField="value"
      [(ngModel)]="selectedItem"
      [valuePrimitive]="true"
      placeholder="Report Type"
    ></kendo-dropdownlist> -->

    <!-- Kendo Excel Export -->
    <kendo-excelexport
      [data]="gridExcelexportDeleted"
      [collapsible]="true"
      fileName="DeletedBlotterRecordsExport.xlsx"
      #excelexportDeleted
    >
      <kendo-excelexport-column field="blotterId" [hidden]="false" [locked]="true" title="Transaction Id">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="clientId" [hidden]="false" [locked]="true" title="clientId" [width]="200">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="productTypeDesc2" title="product Type" [width]="200">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="transactionTypeDesc" title="TransactionTypeId" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="accountNumber" title="Account Number" [width]="350">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="deletedBy" title="Deleted By" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="deletedDate" title="Deleted Date" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="productName" title="ProductName" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="amount" title="amount" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateReceived" title="Date Received" [width]="50">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.dateReceived | date : 'MM-dd-yyyy:mm:ss' }}
        </ng-template>
      </kendo-excelexport-column>
      <kendo-excelexport-column field="approvedBy" title="ApprovedBy" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="approvedByDate" title="approvedByDate" [width]="50">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.approvedByDate | date : 'MM-dd-yyyy:mm:ss' }}
        </ng-template>
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateSubmitted" title="dateSubmitted" [width]="50">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.dateSubmitted | date : 'MM-dd-yyyy:mm:ss' }}
        </ng-template>
      </kendo-excelexport-column>
      <kendo-excelexport-column field="trackingNumber" title="trackingNumber" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateSigned" title="dateSigned" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="newAccountForm" title="newAccountForm" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="dateOfNewAccountForm" title="dateOfNewAccountForm" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="statusTypeDesc" title="StatusType Desc" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="blotterReviewId" title="Blotter Review  ID" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="repFirstName" title="Rep First Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="repMiddleName" title="Rep Middle Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="repLastName" title="Rep Last Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="accountName" title="AccountName" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="mutualFundClassBdisclosureForm" title="mutualFundClassBdisclosureForm" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="clientFirstName" title="Client First Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="clientMiddleName" title="Client Middle Name" [width]="50">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="clientLastName" title="Client Last Name" [width]="50">
      </kendo-excelexport-column>
    </kendo-excelexport>
  </div>
</div>
